<template>
  <v-layout row wrap>
    <v-flex
      xs12
      mb-3
    >
      <v-layout row wrap>
        <v-flex
          xs12
          md3
        >
          <span class="ml-1 label">
            {{ $t('message.bizgainOnboarding.summaryPage.Objective') }}:
          </span>
        </v-flex>
        <v-flex
          xs12
          md9
        >
          <v-layout>
            <v-flex xs1>
              <div>
                <img :src="objectiveType.leadGeneration.imageUrl" class="imageIcon">
              </div>
            </v-flex>
            <v-flex xs9>
              <span class="label detail-field" :class="{'ml-1': $vuetify.breakpoint.xsOnly}">
                {{ $t('message.bizgainOnboarding.summaryPage.leadsObjective') }}
              </span>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      xs12
      mb-3
    >
      <v-layout row wrap>
        <v-flex
          xs12
          md3
        >
          <span class="ml-1 label">
            {{ $t('message.bizgainOnboarding.summaryPage.DetailsToCollectFromLeads') }}:
          </span>
        </v-flex>
        <v-flex
          xs12
          md9
        >
          <v-layout v-if="!isEditLeadFormFields">
            <v-flex xs1>
              <v-icon class="greyIcon">
                badge
              </v-icon>
            </v-flex>
            <v-flex xs9>
              <span class="ml-1 label detail-field" :class="{'ml-1': $vuetify.breakpoint.xsOnly}">
                {{ formFieldsString }}
              </span>
            </v-flex>
            <v-flex xs2>
              <v-icon class="editIcon" @click="isEditLeadFormFields = true">
                edit
              </v-icon>
            </v-flex>
          </v-layout>
          <v-layout v-if="isEditLeadFormFields">
            <lead-form-fields :prefilled-fields="formFields" :is-summary="true" @formFieldsUpdate="setFormFields">
              <template v-slot:button>
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs12 md3>
                      <v-btn
                        depressed
                        class="mx-0 next-btn-color next-btn-xs"
                        :loading="isLoadingLeadFormFields"
                        @click="updateLeadFormFields()"
                      >
                        Save
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </template>
            </lead-form-fields>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      xs12
      mb-1
    >
      <v-layout row wrap>
        <v-flex
          xs12
          md3
        >
          <span class="ml-1 label">
            {{ $t('message.bizgainOnboarding.summaryPage.ServicesPromoted') }}:
          </span>
        </v-flex>
        <v-flex
          xs12
          md9
        >
          <v-layout v-if="!isEditPromoteServices">
            <v-flex xs1>
              <v-icon class="greyIcon">
                home_repair_service
              </v-icon>
            </v-flex>
            <v-flex xs9>
              <span class="label detail-field" :class="{'ml-1': $vuetify.breakpoint.xsOnly}">
                {{ selectedServicesString }}
              </span>
            </v-flex>
            <v-flex sm2 xs2 md2>
              <v-icon class="editIcon" @click="isEditPromoteServices = !isEditPromoteServices">
                edit
              </v-icon>
            </v-flex>
          </v-layout>
          <v-layout v-if="isEditPromoteServices">
            <v-flex xs12>
              <v-card class="pa-2 mt-2">
                <v-layout row wrap class="promote-services">
                  <v-flex
                    xs12
                  >
                    <div>
                      <v-autocomplete
                        class="pt-0 mt-0"
                        v-model="selectedServices"
                        :items="allServices"
                        item-text="name"
                        item-value="id"
                        :placeholder="`Ex: ${allServices[0].name }`"
                        name="selectedServices"
                        v-validate="'required'"
                        @focus="clearErrorByField($event, 'selectedServices')"
                        :error="errors.has('selectedServices')"
                        :error-messages="
                          errors.first('selectedServices')
                            ? $t(
                              'message.bizgainOnboarding.selectedServiceWarning')
                            : null
                        "
                        small-chips
                        multiple
                        append-icon="keyboard_arrow_down"
                        :return-object="true"
                        :menu-props="{ maxHeight: 200 }"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            small
                            color="primary-transperant-variant"
                            text-color="black"
                            class="selected-services"
                            :selected="data.selected"
                          >
                            <span
                              class="selected-service-item"
                            >{{ data.item.name }}
                              <v-icon
                                small
                                class="
                              pr-1"
                                right
                                color="black"
                                @click="removeSelectedService(data.item)"
                              >
                                close
                              </v-icon>
                            </span>
                          </v-chip>
                        </template>
                      </v-autocomplete>
                    </div>
                  </v-flex>
                  <v-layout v-if="selectedServices.length > 1">
                    <alert
                      :icon-color="'primary'"
                      :icon-width="`${ !$vuetify.breakpoint.xsOnly ? 'xs1' : 'xs2' }`"
                      :outline="true"
                      :outline-color="'primary'"
                      :message="$t('message.bizgainOnboarding.promoteServiceAlert')"
                      :col-width="'xs12 sm10'"
                    />
                  </v-layout>
                  <v-flex xs12 md3>
                    <v-btn
                      depressed
                      :disabled="!isServiceSelected"
                      :loading="isLoadingUpdatePromoteServices"
                      class="mx-0 next-btn-color next-btn-xs"
                      @click="updateSelectedServices()"
                    >
                      Save
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      xs12
      mb-1
      v-if="false"
    >
      <v-layout row wrap>
        <v-flex
          xs12
          md3
        >
          <span class="ml-1 label">
            {{ $t('message.bizgainOnboarding.summaryPage.PromotionTag') }}
          </span>
        </v-flex>
        <v-flex
          xs12
          md9
        >
          <v-layout>
            <v-flex xs1>
              <v-icon class="greyIcon">
                local_offer
              </v-icon>
            </v-flex>
            <v-flex xs9>
              <span class="label detail-field" :class="{'ml-1': $vuetify.breakpoint.xsOnly}">
                {{ offerTagline }}
              </span>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  VLayout,
  VFlex,
  VIcon,
  VBtn,
  VCard,
  VAutocomplete,
  VChip
} from 'vuetify/lib';
import Alert from 'Components/Alert/Alert';
import { objectiveType, leadFormEnabledFields, leadFormFieldsByValue, bizgainOnboardingRoutes } from '../../../constants';
import LeadFormFields from '../../SelectObjective/components/LeadFormFields.vue';
import clearErrorByField from 'Mixins/clearErrorByField';
import { mapGetters, mapActions } from 'vuex';
import { Chat } from 'Mixins/chat';
import { i18n } from '@/lang/';

export default {
  mixins: [Chat, clearErrorByField],
  components: {
    VLayout,
    VFlex,
    VIcon,
    VBtn,
    VCard,
    VChip,
    Alert,
    VAutocomplete,
    LeadFormFields
  },
  props: [
    'offerTagline'
  ],
  data() {
    return {
      objectiveType,
      leadFormEnabledFields,
      leadFormFieldsByValue,
      bizgainOnboardingRoutes,
      isEditLeadFormFields: false,
      isLoadingLeadFormFields: false,
      formFields: [],
      newBusinessDetails: null,
      isEditPromoteServices: false,
      isLoadingUpdatePromoteServices: false,
      allServices: [],
      selectedServices: []
    }
  },
  created(){
    if (this.businessDetails.hasOwnProperty('creativeDetail')){
      if (this.businessDetails.creativeDetail.hasOwnProperty('leadAdConfiguration') && this.businessDetails.creativeDetail.leadAdConfiguration.formFields.length > 0)
      {
        this.formFields = this.businessDetails.creativeDetail.leadAdConfiguration.formFields;
      }
    }
    this.allServices = this.services.map(function(val, index){
      return { id: index, name: val };
    });
    if (this.promoteServices){
      this.promoteServices.forEach(promoteService => {
        let selectedService = this.allServices.find(service => service.name === promoteService);
        if (selectedService) {
          this.selectedServices.push(selectedService)
        }
      });
    }
  },
  computed: {
    ...mapGetters(['businessDetails', 'promoteServices', 'services']),
    formFieldsString(){
      let details = [];
      for(let value of this.formFields){
        details.push(this.leadFormEnabledFields[this.leadFormFieldsByValue[value]].label);
      }
      return details.join(', ');
    },
    selectedServicesString(){
      return this.promoteServices.join(', ');
    },
    isServiceSelected() {
      return this.selectedServices.length > 0;
    }
  },
  methods: {
    ...mapActions(['patchBusinessDetails']),
    async updateLeadFormFields(){
      try {
        if(this.businessDetails){
          this.isLoadingLeadFormFields = true;
          this.newBusinessDetails = JSON.parse(JSON.stringify(this.businessDetails));
          var selectedObjectiveType = null;
          if (this.formFields.length > 0){
            this.newBusinessDetails.creativeDetail.leadAdConfiguration.formFields = this.formFields;
          }
          selectedObjectiveType = i18n.tc(objectiveType.leadGeneration.conversionTitle);
          await this.updateUserProperties({ objectiveType: selectedObjectiveType });
          let payload = {
            sessionId: this.businessDetails.sessionId,
            oldBusinessDetails: this.businessDetails,
            newBusinessDetails: this.newBusinessDetails
          };
          await this.patchBusinessDetails(payload);
          this.isEditLeadFormFields = false;
          this.isLoadingLeadFormFields = false;
        }
      }
      catch {
        this.isLoadingLeadFormFields = false;
      }
    },
    goToSelectObjective(){
      this.$router.push({ name: this.bizgainOnboardingRoutes.SelectObjective.name, params: { isAppFlow: true, summary: true } });
    },
    goToPromoteServices(){
      this.$router.push({ name: this.bizgainOnboardingRoutes.PromoteServices.name, params: { isAppFlow: true } });
    },
    goToExtractOfferDetails(){
      this.$router.push({ name: this.bizgainOnboardingRoutes.ExtractOfferDetails.name, params: { isAppFlow: true } });
    },
    setFormFields(selectedFields){
      this.formFields = selectedFields;
      this.formFields.sort();
    },
    removeSelectedService (service) {
      this.selectedServices.splice(this.selectedServices.indexOf(service), 1);
    },
    async updateSelectedServices() {
      if (this.selectedServices){
        try {
          if (this.businessDetails){
            this.isUpdatePromoteServices = true;
            this.isLoadingUpdatePromoteServices = true;
            this.newBusinessDetails = JSON.parse(JSON.stringify(this.businessDetails));
            if (this.newBusinessDetails && this.newBusinessDetails.creativeDetail) {
              this.newBusinessDetails.creativeDetail.promoteServices = this.selectedServices.map(service=>service.name);
              let payload = {
                sessionId: this.businessDetails.sessionId,
                oldBusinessDetails: this.businessDetails,
                newBusinessDetails: this.newBusinessDetails
              };
              await this.patchBusinessDetails(payload);
              this.isLoadingUpdatePromoteServices = false;
              this.isEditPromoteServices = false;
              if(this.isError){
                this.isLoadingUpdatePromoteServices = false;
              }
            }
          }
        }
        catch {
          this.isLoadingUpdatePromoteServices = false;
          this.isEditPromoteServices = false;
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.greyIcon{
  color: #727891;
}
.editIcon{
  color: #13abb1;
}
.imageIcon{
  height: 28px;
  width: 25px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.detail-field{
  color: black;
  align-self: center;
}
@media only screen and (max-width: 600px) {
  .editIcon{
    color: #727891;
  }
}
.selected-services.v-chip {
    height: auto !important;
}

::v-deep .selected-services.v-chip .v-chip__content{
  height: auto !important;
}

::v-deep .selected-service-item {
  white-space: initial !important;
}
</style>

